var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgMailing = function SvgMailing(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 23,
    height: 28,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#F28230",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 2,
    d: "M21.95 3.03a1.14 1.14 0 0 0-1.141-1.136H2.142c-.63 0-1.142.51-1.142 1.141v22.337c0 .527.427.955.955.955h18.903c.63 0 1.142-.511 1.142-1.142V12.198z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#F28230",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 2,
    d: "m21.721 25.933-9.26-7.3a1.83 1.83 0 0 0-2.288.015l-8.991 7.285M1 12.527l8.488 6.676M13.13 19.16 22 12.632M4.83 6.143h13.226M4.83 10.112h13.226"
  })));
};
export default SvgMailing;